module.exports = __webpack_public_path__ + "static/media/renewal_trophy.16fd5410.png";